export default __webpack_public_path__ + "static/media/PDF.cd6a76ab.svg";